import type { EventBase } from './event';

interface EventAgentsBulkCreateCompleteResult {
  index: number;
  provider_uuid: string;
  provider_created: boolean;
  association_id: number;
  association_created: boolean;
}

interface EventAgentsBulkCreateComplete extends EventBase<'agents.bulk.create.complete'> {
  data: {
    total: number;
    providers_created: number;
    providers_updated: number;
    associations_created: number;
    associations_skipped: number;
    results: EventAgentsBulkCreateCompleteResult[];
  };
}

interface EventAgentsBulkCreateFailed extends EventBase<'agents.bulk.create.failed'> {
  data: {
    message: string;
  };
}

type AgentsEvent
  = | EventAgentsBulkCreateComplete
  | EventAgentsBulkCreateFailed;

const AGENTS_EVENT_KEYS = [
  'agents.bulk.create.complete',
  'agents.bulk.create.failed',
] as const satisfies readonly AgentsEvent['eventKey'][];

export {
  AGENTS_EVENT_KEYS,
  type AgentsEvent,
  type EventAgentsBulkCreateComplete,
  type EventAgentsBulkCreateCompleteResult,
  type EventAgentsBulkCreateFailed,
};
